import { render, staticRenderFns } from "./main.tiposdevolucion.vue?vue&type=template&id=55b720a8"
import script from "./main.tiposdevolucion.vue?vue&type=script&lang=js"
export * from "./main.tiposdevolucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports